import React, { useState, useEffect } from 'react';
import { Box, VStack, HStack, Text, Icon, Badge, Flex, Image } from '@chakra-ui/react';
import { FiChevronRight, FiBell } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { authAPI, resolveImageUrl } from '../services/api';
import LogoPulseLoader from '../components/LogoPulseLoader';
import { formatDate } from '../utils/dateUtils';

// 統一用 dateUtils 強制以 Asia/Taipei 顯示
const fmtDate = formatDate;

const ParentAnnouncementsPage = () => {
    const navigate = useNavigate();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchItems = async () => {
        try {
            const res = await authAPI.announcements.getMy();
            setItems(Array.isArray(res.data) ? res.data : []);
        } catch (e) {
            setItems([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchItems();
        const onRefresh = () => fetchItems();
        window.addEventListener('data-refresh', onRefresh);
        return () => window.removeEventListener('data-refresh', onRefresh);
    }, []);

    if (loading) {
        return <Flex justify="center" align="center" h="50vh"><LogoPulseLoader /></Flex>;
    }

    return (
        <Box px={4} pb="calc(env(safe-area-inset-bottom) + 24px)">
            {items.length === 0 ? (
                <Flex direction="column" align="center" justify="center" py={20} color="onCanvas.300">
                    <Icon as={FiBell} boxSize={14} mb={3} />
                    <Text>目前沒有公告</Text>
                </Flex>
            ) : (
                <VStack spacing={3} align="stretch">
                    {items.map((a) => (
                        <HStack
                            key={a.id}
                            onClick={() => navigate(`/parent/announcements/${a.id}`, { state: { fromList: true } })}
                            bg="white" p={4} borderRadius="2xl" boxShadow="sm"
                            border="1px solid" borderColor="gray.100" spacing={3}
                            cursor="pointer" _active={{ opacity: 0.7 }}
                            borderLeft="5px solid"
                            borderLeftColor={a.is_emergency ? 'red.400' : (a.is_read ? 'gray.200' : 'blue.400')}
                        >
                            {resolveImageUrl(a.cover_image_url) && (
                                <Image src={resolveImageUrl(a.cover_image_url)} boxSize="56px" borderRadius="lg" objectFit="cover" alt="" />
                            )}
                            <VStack align="start" spacing={1} flex={1} minW={0}>
                                <HStack spacing={2}>
                                    {a.is_emergency && <Badge colorScheme="red" borderRadius="full">緊急</Badge>}
                                    {!a.is_read && <Box boxSize="8px" borderRadius="full" bg="blue.400" />}
                                    <Text fontWeight="bold" noOfLines={1} color="gray.800">{a.title}</Text>
                                </HStack>
                                <Text fontSize="xs" color="onCanvas.300">{fmtDate(a.published_at || a.created_at)}</Text>
                            </VStack>
                            <Icon as={FiChevronRight} color="onCanvas.300" />
                        </HStack>
                    ))}
                </VStack>
            )}
        </Box>
    );
};

export default ParentAnnouncementsPage;
